export default "__VITE_ASSET__X5lYGASA__"